module.exports = __webpack_public_path__ + "img/jjsg.25bfbf01.png";